export const environment = {
  production: false,
  baseUrl: '',
  useHash: false,
  hmr: false,
  showThemeToggle: true,
  translateText: false,
  collapsibleSidebar: false,
  showChatbot: true,
  build: 'Development',
  version: '4.0.0',

  useAppInsights: false,
  appInsightsInstrumentationKey: 'e6f30bb6-a160-4d69-a8d2-8642430020c1',
  useTimeout: false,
  idleInterval: 1800,
  displaySidebar: true,
  theme: 'light',
  publicApi: 'https://test-orelap.oregon.gov/api/public/',
  privateApi: 'https://test-orelap.oregon.gov/api/private/',
  canManageB2CUsers: true,
  auth: {
    defaultAuth: "B2C", //options: AAD or B2C
    useAdIdentity: false,
    b2c: {
      clientId: '75d2024f-d324-4289-8db7-3ea5503a289b',
      authority: 'https://ohaorelapdevb2c.b2clogin.com/',
      authorityDomain:'ohaorelapdevb2c.b2clogin.com/',
      domain: 'ohaorelapdevb2c.onmicrosoft.com/',
      signUpSignInPolicy: 'B2C_1_ORELAP_DEV_SUSI',
      scopes: ['openid', 'https://ohaorelapdevb2c.onmicrosoft.com/75d2024f-d324-4289-8db7-3ea5503a289b/User.Access'],
      redirectUri: 'https://test-orelap.oregon.gov/',
      postLogoutRedirectUri: 'https://test-orelap.oregon.gov/'
    },
    aad: {
      clientId: '817cff66-e6a4-44a7-a218-37e196c91493',
      scopes: ['api://817cff66-e6a4-44a7-a218-37e196c91493/user.access'],
      groups: ['8474cfc8-154b-4507-b834-3eb85a9bd5d0'],
      authority: 'https://login.microsoftonline.com/658e63e8-8d39-499c-8f48-13adc9452f4c/',
      redirectUri: 'https://test-orelap.oregon.gov/',
    }
  },
  enableHttpsRedirect: false,
  staffInbox: "chae.shin@odhsoha.oregon.gov",
};
